// istanbul ignore file
import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { StopEventsPropagation } from './StopEventsPropagation';

export const createPortalWithoutEventsPropagation = (reactNode: ReactNode, container: Element, key?: string | null) =>
  ReactDOM.createPortal(<StopEventsPropagation>{reactNode}</StopEventsPropagation>, container, key);
